import React from 'react';
import { Link } from 'react-router-dom';
// import ReactDOM from 'react-dom';
// import jQuery from 'jquery';
// import { this.props.history } from 'react-router';
import { connect } from 'react-redux';
import * as SVGICONS from '../../../images/img/images';
import { bindActionCreators } from 'redux';
import * as appointmentActions from '../../../actions/appointmentActions';
import * as documentActions from '../../../actions/documentUploadActions';
import Consultation from '../../sitemanagement/consultation';
import moment from 'moment';
import Moment from 'react-moment';
import * as ImageUrl from '../../../constants/constant.js';
import { confirmAlert } from 'react-confirm-alert';
import * as constant from "../../../constants/constant";
import 'react-confirm-alert/src/react-confirm-alert.css';
import * as dashboardActions from "../../../actions/dashboardActions";
import $ from "jquery";
import { Button } from 'react-bootstrap'

import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import "../../../styles/scss/specialistConsultation.css";
//specialist/appointment-consultation/5cb5a238d9d3d114626d069c
class consultationForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      patientHistory: [],
      appointmentDetails: [],
      showForm: 'none',
      showconsult: false,
      "chiefComplaints": "",
      "physicalExaminationFindings": "",
      "diagnosis": "",
      "treatmentPlan": "",
      "currentMedication": "",
      "prescription": "",
      "allergies": "",
      "familyHistory": "",
      "personalHistory": "",
      "pastHistory": "",
      "symptoms": '',
      "docsymptoms": '',
      "spinner": false,
      'consultbuttonflag': 'block',
      'symptomsHistory': [],
      'consultation': '',
      logoutButton: false,
      isDisclaimer: localStorage.getItem('isDisclaimerConsultation') ? localStorage.getItem('isDisclaimerConsultation') : false,
      disclaimerOkstate: false,
      downloadPath: '',
      isConsultButtonShow: false,
      initialRender: true,
      startDate: null,
      inputdp: false,
      inputOth: false,
      inputOthAll: false
    };
    this.goToVideoCallPage = this.goToVideoCallPage.bind(this);
    this.Consult = this.Consult.bind(this)
    this.hideconsultationModal = this.hideconsultationModal.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onChangeText = this.onChangeText.bind(this)
    this.saveConsultation = this.saveConsultation.bind(this)
    this.onLogoutclick = this.onLogoutclick.bind(this)
    this.toggle = this.toggle.bind(this)
    this._logout = this._logout.bind(this)
    this.Disclaimer = this.Disclaimer.bind(this)

  }

  _logout(event) {
    let userId = localStorage.getItem('userId')
    this.props.logoutAction.logout({ 'userId': userId })
    event.preventDefault();
    localStorage.clear();
    this.props.history.push('/');
  }
  goToVideoCallPage() {
    var videoCall = {
      appointmentId: localStorage.getItem('appointmentId'),
      patientId: localStorage.getItem('patientId'),
      doctorId: localStorage.getItem('userId')
    }
    localStorage.setItem('videoCall', JSON.stringify(videoCall))
    localStorage.setItem('consultationOpenFrom', 'VideoCall')

    // window.open(videoCall.appointmentId, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=1000,left=1000,width=1000,height=1000");
    this.props.history.push('/specialist/waiting-room-caller')
  }

  componentWillMount() {
    localStorage.setItem('appointmentId', this.props.match.params.appointmentId);
    let appointmentObj = {
      appointmentId: localStorage.getItem('appointmentId')
    }
    var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    var consultStatus = localStorage.getItem('consult');
    if (consultStatus == 'consult') {

      this.setState({
        showForm: 'block',
        initialRender: true
      })
    }
    if (consultStatus == 'consult') {
      this.setState({ isConsultButtonShow: true })
    }
    let appointmentHistory = {
      patientId: localStorage.getItem('patientId'),
      doctorId: localStorage.getItem('userId')
    }
    this.props.actions.getConsultationDetail(appointmentObj, this.props);
    this.props.actions.getAppointmentDetails(appointmentObj, this.props);
    this.props.documentactions.getAppointmentDocument(appointmentObj, this.props);
    this.props.actions.getPatientAllConsultHistory(appointmentHistory, this.props);
  }
  Disclaimer() {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui disclaimer_appointement'>
            <Button style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}>Close</Button>

            <h1>Disclaimer</h1>
            {/* <p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p> */}
            <span>You have chosen to download a patient file.  This document contains patient-specific sensitive information and MUST NOT be shared with any third party.  You must ensure that the document is kept securely and destroyed after use.  The Terms and Conditions and Patient Confidentiality Agreement apply to this and other sensitive documents at all times.</span>
            <div className="bottomBtn text-center"><button className="btn btn-warning btn-lg" type="button" onClick={() => {

              let downloadPath = this.state.appointmentDetails && this.state.appointmentDetails.patient ? constant.PRODUCTION_IMAGE_URL + "uploads/" + this.state.appointmentDetails.patient[0]._id + "/" + this.state.consultation : '';
              window.open(downloadPath, '_blank')
              onClose()
            }}
            >Ok</button></div>
          </div>
        )
      }
    })
  }
  componentDidMount() {

  }
  componentWillUnmount() {
    localStorage.setItem('consult', 'false')
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.appointmentDetails) {
      this.setState({
        appointmentDetails: nextProps.appointmentDetails
      })
    }
    if (nextProps.patientAllConsultHistory) {
      this.setState({
        patientHistory: nextProps.patientAllConsultHistory,
      })
    }
    if (nextProps.consultationDet && this.state.initialRender) {
      this.setState({
        consultationDet: nextProps.consultationDet,
        docsymptoms: nextProps.consultationDet.docSymptoms,
        // symptoms: nextProps.consultationDet.symptoms,
        allergies: nextProps.consultationDet.allergies,
        appointmentMode: nextProps.consultationDet.appointmentMode,
        chiefComplaints: nextProps.consultationDet.chiefComplaints,
        currentMedication: nextProps.consultationDet.currentMedication,
        diagnosis: nextProps.consultationDet.diagnosis,
        familyHistory: nextProps.consultationDet.familyHistory,
        gender: nextProps.consultationDet.gender,
        pastHistory: nextProps.consultationDet.pastHistory,
        patientName: nextProps.consultationDet.patientName,
        patientProfileImage: nextProps.consultationDet.patientProfileImage,
        personalHistory: nextProps.consultationDet.personalHistory,
        physicalExaminationFindings: nextProps.consultationDet.physicalExaminationFindings,
        prescription: nextProps.consultationDet.prescription,
        treatmentPlan: nextProps.consultationDet.treatmentPlan,
        appointmentDocument: nextProps.appointmentDocument,
        symptomsHistory: nextProps.patientAllConsultHistory.patientAppointments ? nextProps.patientAllConsultHistory.patientAppointments : '',
        consultation: nextProps.consultationDet.consultation ? nextProps.consultationDet.consultation : ''
      })
      this.setState({
        initialRender: false
      })
      if (Object.keys(nextProps.consultationDet).length > 7 && (nextProps.consultationDet.isConsulted && nextProps.consultationDet.isConsulted == true)) {
        this.setState({
          'consultbuttonflag': 'none',
          'showForm': 'block',
        })
      }
    }
  }


  Consult() {
    this.setState({
      'showForm': 'block',
      isConsultButtonShow: true
    })
  }

  hideconsultationModal() {
    this.setState({ showconsult: false });
  }


  onChange(type) {
    if (type == 'past') {
      this.setState({ 'data': this.state.patientHistory.pastInfo })
      this.setState({ 'heading': 'Past History' })
      this.setState({ showconsult: true });
    }
    if (type == 'family') {
      this.setState({ 'data': this.state.patientHistory.familyHistoryInfo })
      this.setState({ 'heading': 'Family History' })
      this.setState({ showconsult: true });
    }
    if (type == 'personal') {
      this.setState({ 'data': this.state.patientHistory.personalInfo })
      this.setState({ 'heading': 'Personal History' })
      this.setState({ showconsult: true });
    }
    if (type == 'allergy') {
      this.setState({ 'data': this.state.patientHistory.allergiesInfo })
      this.setState({ 'heading': 'Allergies History' })
      this.setState({ showconsult: true });
    }
    if (type == 'prescription') {

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className='custom-ui disclaimer_appointement'>
              {/* <Button style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}>Close</Button> */}

              <h1>Disclaimer</h1>
              {/* <p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p> */}
              <span>You have chosen to download a patient file.  This document contains patient-specific sensitive information and MUST NOT be shared with any third party.  You must ensure that the document is kept securely and destroyed after use.  The Terms and Conditions and Patient Confidentiality Agreement apply to this and other sensitive documents at all times.</span>
              <div className="bottomBtn text-center"><button className="btn btn-warning btn-lg" type="button" onClick={() => {
                var patientId = localStorage.getItem('patientId');
                this.setState({ 'data': this.state.patientHistory.patientAppointments })
                this.setState({ 'heading': 'Prescriptions' })
                this.setState({ showconsult: true });
                onClose()
              }}
              >Ok</button></div>
            </div>
          )
        }
      })


    }
    if (type == 'docs') {

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className='custom-ui disclaimer_appointement'>
              {/* <Button style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}>CLose</Button> */}

              <h1>Disclaimer</h1>
              {/* <p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p> */}
              <span>You have chosen to download a patient file.  This document contains patient-specific sensitive information and MUST NOT be shared with any third party.  You must ensure that the document is kept securely and destroyed after use.  The Terms and Conditions and Patient Confidentiality Agreement apply to this and other sensitive documents at all times.</span>
              <div className="bottomBtn text-center"><button type="button" onClick={() => {
                var patientId = this.state.appointmentDetails.patient._id;
                this.setState({ 'patientId': patientId })
                this.setState({ 'data': this.state.appointmentDocument })
                this.setState({ 'heading': 'Uploaded Documents' })
                this.setState({ showconsult: true });
                onClose()
              }}
                className="btn btn-warning btn-lg">Ok</button></div>
            </div>
          )
        }
      })

    }
    if (type == 'syms') {
      var patientId = this.state.appointmentDetails.patient._id;
      this.setState({ 'patientId': patientId })
      this.setState({ 'data': this.state.appointmentDetails })
      this.setState({ 'heading': 'Uploaded Symptoms' })
      this.setState({ showconsult: true });
    }
    // this.setState({ showconsult: true });
  }

  saveConsultation() {
    confirmAlert({
      title: 'Confirm',
      message: 'Do you wish to Save and Close the appointment?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            var consultObj = {
              "patientId": localStorage.getItem('patientId'),
              "appointmentId": localStorage.getItem('appointmentId'),
              "doctorId": localStorage.getItem('userId'),
              "chiefComplaints": this.state.chiefComplaints,
              "physicalExaminationFindings": this.state.physicalExaminationFindings,
              "diagnosis": this.state.diagnosis,
              "treatmentPlan": this.state.treatmentPlan,
              "currentMedication": this.state.currentMedication,
              "prescription": this.state.prescription,
              "allergies": this.state.allergies,
              "familyHistory": this.state.familyHistory,
              "personalHistory": this.state.personalHistory,
              "pastHistory": this.state.pastHistory,
              // "symptoms": this.state.symptoms,
              "docSymptoms": this.state.docsymptoms
            }
            this.setState({
              spinner: true
            })
            this.props.actions.saveConsultation(consultObj, this.props)
            if (localStorage.getItem('consultationOpenFrom') && localStorage.getItem('consultationOpenFrom') == 'VideoCall') {
              localStorage.removeItem('consultationOpenFrom')
              window.close();
            }
          }
        },
        {
          label: 'No',
          onClick: () => { }
        }
      ]
    })


  }
  onLogoutclick(data) {
    if (this.state.logoutButton == false) {
      this.setState({
        logoutButton: true
      });
    }
    else {
      this.setState({
        logoutButton: false
      });
    }
  }
  onChangeText(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  toggle() {
    var windowWidth = $(window).width();
    if (windowWidth < 768) {
      $("body").toggleClass("sidebar-open");
    } else {
      $("body").toggleClass("sidebar-collapse");
    }
  }
  handleChange = date => {
    this.setState({
      startDate: date
    });
  };

  render() {
    let options = this.props.userTypeData;

    var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    var isAssistant = user.assistId ? true : false;
    var defaultImagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';

    if (user.image == constant.DEFAULT_USER_IMAGE) {
      // var imagePath = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
      var imagePath = defaultImagePath;
    } else {
      var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
    }
    // let appointmentDetails = this.state.appointmentDetails;
    let patientHistory = this.state.patientHistory;
    let patientHisFlag = localStorage.getItem('patienthistory') ? localStorage.getItem('patienthistory') : '';
    let patientHisUrl = "/specialist/appointment-history/" + localStorage.getItem('patientId');
    let patientImage = this.state.appointmentDetails.patient ? (this.state.appointmentDetails.patient[0].gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png') : '';
    // if (this.state.appointmentDetails && this.state.appointmentDetails.patient && this.state.appointmentDetails.patientdet[0].profileImage != 'noUserImage.jpg') {
    // 	patientImage = this.state.appointmentDetails && this.state.appointmentDetails.patient ? ImageUrl.PRODUCTION_IMAGE_URL + 'uploads/' + this.state.appointmentDetails.patient[0]._id + '/' + this.state.appointmentDetails.patientdet[0].profileImage : '';
    // } else if (this.state.appointmentDetails && this.state.appointmentDetails.patient && this.state.appointmentDetails.patientdet[0].profileImage == 'noUserImage.jpg') {
    // 	patientImage = this.state.appointmentDetails && this.state.appointmentDetails.patient && this.state.appointmentDetails.patient[0].gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png';
    // }
    let consultationpres = this.state.appointmentDetails && this.state.appointmentDetails.patient ? constant.PRODUCTION_IMAGE_URL + "uploads/" + this.state.appointmentDetails.patient[0]._id + "/" + this.state.consultation : '';
    var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    var condition = (((user.userName != undefined || user.gender != undefined) && user.availabilityCount > 0) && user.isVerified == '2');
    var userType = localStorage.getItem('userType');

    const { appointmentMode } = this.state.appointmentDetails
    return (
      <div>
        <header className='section-consultation__main main-header'>
          <Link
            to={condition ? "/specialist/my-appointment" : null}
            className='logo'
          >
            <span className='logo-mini'>
              {userType === "specialist" ? (
                <img src={require("../../../images/images/logo.svg")} alt='' />
              ) : (
                <img
                  src={require("../../../images/img/logo_er_ms.png")}
                  alt=''
                />
              )}
            </span>
            <span className='logo-lg'>
              {userType === "specialist" ? (
                <img src={require("../../../images/images/logo.svg")} alt='' />
              ) : (
                <img
                  src={require("../../../images/img/logo_er_old.png")}
                  alt=''
                />
              )}
            </span>{" "}
          </Link>
          <nav className='navbar navbar-static-top' role='navigation'>
            <Link
              href='#'
              className='sidebar-toggle'
              data-toggle='push-menu'
              role='button'
              onClick={this.toggle}
            >
              {" "}
              <img
                src={require("../../../images/img/menu_list.svg")}
                alt=''
              />{" "}
              <span className='sr-only'>Toggle navigation</span>{" "}
            </Link>
            <div className='navbar-custom-menu'>
              <ul className='nav navbar-nav'>
                <li
                  ref={(node) => {
                    this.node = node;
                  }}
                  onClick={this.handleClick}
                  className={
                    this.state.logoutButton == true
                      ? "dropdown user user-menu show"
                      : "dropdown user user-menu"
                  }
                >
                  <Link
                    href='#'
                    className='dropdown-toggle'
                    data-toggle='dropdown'
                  >
                    <img
                      src={imagePath}
                      className='user-image'
                      alt='User Image'
                      onError={(e) => {
                        e.target.src = defaultImagePath;
                      }}
                    />
                    <span className='hidden-xs name-capitalize'>
                      {user.firstName ? user.firstName : ""}{" "}
                      {user.lastName ? user.lastName : ""}
                    </span>{" "}
                  </Link>
                  <ul
                    className={
                      this.state.logoutButton === true
                        ? "dropdown-menu popupdropdown show"
                        : "dropdown-menu popupdropdown"
                    }
                  >
                    <li className='user-setting'>
                      {" "}
                      <Link
                        to={{ pathname: "/specialist/my-accounts", state: 1 }}
                      >
                        <img
                          src={require("../../../images/accountb.png")}
                          className='user-image'
                          alt='User Image'
                          onError={(e) => {
                            e.target.src = defaultImagePath;
                          }}
                        />
                        <span>My Account</span>
                      </Link>
                    </li>
                    <li className='user-setting'>
                      {" "}
                      <Link
                        to={{ pathname: "/specialist/my-settings", state: 1 }}
                      >
                        <img
                          src={require("../../../images/Slicing/Settings-profile.png")}
                          className='user-image'
                          alt='User Image'
                          onError={(e) => {
                            e.target.src = defaultImagePath;
                          }}
                        />
                        <span>Settings</span>
                      </Link>
                    </li>
                    <li
                      className='user-footer passwordLink'
                      // style={{ textAlign: "center" }}
                    >
                      <Link className='uploadLink' onClick={this._logout}>
                        <img
                          src={require("../../../images/Slicing/logout-profile.png")}
                          className='user-image'
                          alt='User Image'
                          onError={(e) => {
                            e.target.src = defaultImagePath;
                          }}
                        />
                        <span> Sign out</span>
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>
        </header>
        <div className='content-wrapper'>
          <section className='content container-fluid'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='section-consultation__wrap'>
                  <div className='section-consultation__title'>
                    <h4 className='section-consultation__title-h4'>
                      Consultation Form
                    </h4>
                    <div className='section-consultation__breadcrumb'>
                      <span className='section-consultation__title-span'>
                        Appointments /{" "}
                      </span>
                      <span className='section-consultation__title-highlight'>
                        Consultation Form
                      </span>
                    </div>
                  </div>
                  <div className='section-consultation__body'>
                    <div className='section-consultation__card'>
                      <div className='section-consultation__content'>
                        <div className='section-consultation__thumbnail'>
                          <img
                            src={require("../../../images/patient_m.png")}
                            alt=''
                          />
                        </div>
                        <div className='section-consultation__info'>
                          <h3 className='section-consultation__info-h3'>
                            Test Patient
                          </h3>
                          <div className='section-consultation__item'>
                            <div className='section-consultation__text'>
                              <div className='section-consultation__text-1'>
                                <h4>Dob</h4>
                                <span>17/03/2015</span>
                              </div>
                              <div className='section-consultation__text-1'>
                                <h4>Appointment Date</h4>
                                <span>30/06/2020</span>
                              </div>
                              <div className='section-consultation__text-1'>
                                <h4>Gender</h4>
                                <span>Male</span>
                              </div>
                            </div>
                            <span className='section-consultation__text-history'>
                              Appointment History
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className='section-consultation__group'>
                        <button className='section-consultation__group-button section-consultation__group-button--consult'>
                          Consult
                        </button>
                        <button className='section-consultation__group-button'>
                          Conference
                        </button>
                      </div>
                    </div>
                    <div className='section-consultation__card'>
                      <div className='section-consultation__info section-consultation__info--card-2'>
                        <h3 className='section-consultation__info-h3'>
                          Allergies
                        </h3>
                        <div className='section-consultation__item'>
                          <div class='form-check form-check-inline'>
                            <input
                              class='form-check-input'
                              type='checkbox'
                              id='inlineCheckbox1'
                              value='option1'
                            />
                            <label
                              class='form-check-label'
                              for='inlineCheckbox1'
                            >
                              NKDA
                            </label>
                          </div>
                          <div class='form-check form-check-inline'>
                            <input
                              class='form-check-input'
                              type='checkbox'
                              id='inlineCheckbox2'
                              value='option2'
                            />
                            <label
                              class='form-check-label'
                              for='inlineCheckbox2'
                            >
                              Penicillin
                            </label>
                          </div>
                          <div class='form-check form-check-inline'>
                            <input
                              class='form-check-input'
                              type='checkbox'
                              id='inlineCheckbox3'
                              value='option3'
                            />
                            <label
                              class='form-check-label'
                              for='inlineCheckbox3'
                            >
                              Sulfa Drugs
                            </label>
                          </div>
                          <div class='form-check form-check-inline'>
                            <input
                              class='form-check-input'
                              type='checkbox'
                              id='inlineCheckbox4'
                              value='option4'
                            />
                            <label
                              class='form-check-label'
                              for='inlineCheckbox4'
                            >
                              Aspirin
                            </label>
                          </div>
                          <div class='form-check form-check-inline'>
                            <input
                              class='form-check-input'
                              type='checkbox'
                              id='inlineCheckbox5'
                              value='option5'
                            />
                            <label
                              class='form-check-label'
                              for='inlineCheckbox5'
                            >
                              Codeine
                            </label>
                          </div>
                          <div class='form-check form-check-inline'>
                            <input
                              class='form-check-input'
                              type='checkbox'
                              id='inlineCheckbox6'
                              value='option6'
                              checked={this.state.inputOth}
                              onChange={e => {
                                this.setState({ inputOth: !this.state.inputOth})
                              }}
                            />
                            <label
                              class='form-check-label'
                              for='inlineCheckbox6'
                            >
                              Other
                              <input
                                type='text'
                                className='form-check__other'
                                disabled={this.state.inputOth === false}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='section-consultation__card'>
                      <div className='section-consultation__info section-consultation__info--card-2'>
                        <h3 className='section-consultation__info-h3'>
                          Past History
                        </h3>
                        <div className='section-consultation__item section-consultation__item--history'>
                          <span className='section-consultation__item-span'>
                            Medical History (including any relevant family
                            history)
                          </span>
                          <textarea className='section-consultation__item-textarea'></textarea>
                        </div>
                        <div className='section-consultation__item section-consultation__item--history'>
                          <span className='section-consultation__item-span'>
                            Current Medication (prescribed items, OTC, herbals,
                            vitamins)
                          </span>
                          <textarea className='section-consultation__item-textarea'></textarea>
                        </div>
                        <div className='section-consultation__item section-consultation__item--history'>
                          <span className='section-consultation__item-span'>
                            Lifestyle (smoker/ non-smoker, alcohol, drugs, daily
                            exercise)
                          </span>
                          <textarea className='section-consultation__item-textarea'></textarea>
                        </div>
                      </div>
                    </div>
                    <div className='section-consultation__card'>
                      <div className='section-consultation__info section-consultation__info--card-2'>
                        <h3 className='section-consultation__info-h3'>
                          Consultation Details
                        </h3>
                        <div className='section-consultation__item section-consultation__item--history'>
                          <span className='section-consultation__item-span'>
                            Reason for Consultation
                          </span>
                          <textarea className='section-consultation__item-textarea'></textarea>
                        </div>
                        <div className='section-consultation__item section-consultation__item--history'>
                          <span className='section-consultation__item-span'>
                            Symptoms
                          </span>
                          <textarea className='section-consultation__item-textarea'></textarea>
                        </div>
                        <div className='section-consultation__item section-consultation__item--history'>
                          <span className='section-consultation__item-span'>
                            Clinical Findings
                          </span>
                          <textarea className='section-consultation__item-textarea'></textarea>
                        </div>
                        <div className='section-consultation__item section-consultation__item--history'>
                          <span className='section-consultation__item-span'>
                            Patient Recommendations
                          </span>
                          <textarea className='section-consultation__item-textarea'></textarea>
                        </div>
                      </div>
                    </div>
                    <div className='section-consultation__card'>
                      <div className='section-consultation__info section-consultation__info--card-2'>
                        <h3 className='section-consultation__info-h3'>
                          Patient Referral and Recommended Follow-up
                        </h3>
                        <div className='section-consultation__item'>
                          <div class='form-check form-check-inline'>
                            <input
                              class='form-check-input'
                              type='checkbox'
                              id='patient1'
                              value='option3'
                            />
                            <label class='form-check-label' for='patient1'>
                              Sulfa Drugs
                            </label>
                          </div>
                          <div class='form-check form-check-inline'>
                            <input
                              class='form-check-input'
                              type='checkbox'
                              id='patient2'
                              value='option4'
                            />
                            <label class='form-check-label' for='patient2'>
                              Aspirin
                            </label>
                          </div>
                          <div class='form-check form-check-inline'>
                            <input
                              class='form-check-input'
                              type='checkbox'
                              id='patient3'
                              value='option5'
                            />
                            <label class='form-check-label' for='patient3'>
                              Codeine
                            </label>
                          </div>
                          <div class='form-check form-check-inline'>
                            <input
                              class='form-check-input'
                              type='checkbox'
                              id='patient4'
                              value='option6'
                              checked={this.state.inputOthAll}
                              onChange={e => {
                                this.setState({ inputOthAll: !this.state.inputOthAll })
                              }}
                            />
                            <label class='form-check-label' for='patient4'>
                              Other
                              <input
                                type='text'
                                className='form-check__other'
                                placeholder='Specify'
                                disabled={this.state.inputOthAll === false}
                              />
                            </label>
                          </div>
                          <div class='form-check form-check-inline'>
                            <input
                              class='form-check-input'
                              type='checkbox'
                              id='patient5'
                              value='option6'
                              checked={this.state.inputdp}
                              onChange={() => {
                                this.setState({ inputdp: !this.state.inputdp });
                                console.log(this.datepicker.input.focus());
                              }}
                            />
                            <label class='form-check-label' for='patient5'>
                              Recommended Follow-up Period

                              <DatePicker
                                ref={(datepicker) => { this.datepicker = datepicker }}
                                selected={this.state.startDate}
                                onChange={this.handleChange}
                                disabled={this.state.inputdp === false}
                                placeholderText='Select Date'
                                className='form-check__other'
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='section-consultation__card'>
                      <div className='section-consultation__info section-consultation__info--card-2'>
                        <h3 className='section-consultation__info-h3'>
                          Prescription Details
                        </h3>
                        <div className='section-consultation__item section-consultation__item--history'>
                          <textarea className='section-consultation__item-textarea section-consultation__item-textarea--tall'></textarea>
                        </div>
                        <div className='section-consultation__group section-consultation__group--submit'>
                          <button className='section-consultation__group-button section-consultation__group-button--save'>
                            Save and Close Appointment
                          </button>
                          <button className='section-consultation__group-button section-consultation__group-button--cancel'>
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div className='Copyrightafterlogin'>
            <p>Medfix &copy; 2018. All rights reserved</p>
          </div>
        </div>
      </div>
    );
  }
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
  return {
    appointmentDetails: state.appointment.appointmentDetails,
    patientAllConsultHistory: state.appointment.patientAllConsultHistory,
    consultationDet: state.appointment.consultationDet,
    appointmentDocument: state.uploadDocument.uploadedImages ? state.uploadDocument.uploadedImages : ''
  };
}

// this tells what action should expose on props
// bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(appointmentActions, dispatch),
    documentactions: bindActionCreators(documentActions, dispatch),
    logoutAction: bindActionCreators(dashboardActions, dispatch)

  };
}
export default connect(mapStateToProps, mapDispatchToProps)(consultationForm);
